import roundMoney from './roundMoney.js'

export default function hasPriceDiscrepancy ({
  amountA,
  amountB,
  tolerance = 0.01
}) {
  const roundedA = roundMoney(amountA) * 100
  const roundedB = roundMoney(amountB) * 100
  const diff = Math.abs(roundedA - roundedB) / 100

  return diff > tolerance
}
